module.exports = __webpack_public_path__ + "img/cloud-02.d5e78e73.svg";